







export default {
    name: 'PlainButton',

    props: {
        text: {
            required: false,
            type: String,
        },
        icon: {
            required: false,
            type: String,
        },
        disabled: {
            required: false,
            type: Boolean,
        },
        type: {
            default: 'button',
            required: false,
            type: String,
        },
    },
};
